import React from 'react';
import { Link } from 'react-router';
import wNumb from 'wnumb';

let priceFormat = wNumb({
    prefix: '$',
    decimals: 0,
    thousand: ','
});

const PackageSearchGridItem = (props) => {
    let price = priceFormat.to(props.data.price);
    return (
        <div className="w-100 w-50-md w-33-lg w-25-wd fl p-a-1-md p-b-1">
            <div className="relative">
                <Link to={props.data.link}>
                    <img className="select-package-image relative" src={props.data.render} alt=""/>
                    <img className="select-package-builder" src={props.data.logo} alt=""/>
                </Link>
            </div>

            <div className="river-select-package-text">
                <div className="cf m-b-05 m-t-05 tc tl-md">
                    <Link to={props.data.link}>
                        <p className="select-package-header small-blue-font m-b-1">LOT {props.data.lot} - {props.data.name}</p>
                    </Link>
                </div>

                <div className="cf m-b-05">
                    <div className="fl w-50 tl">
                        <p className="select-package-price"><span className="small-grey-font">From  </span>{price}</p>
                    </div>

                    <div className="fr w-50 tr select-package-icons">
                        <ul>
                            <li> <span>{props.data.bed}</span>&nbsp;<img className="fr" src='/wp-content/themes/fyansford/images/bed-icon.svg' alt="" width="25px"/></li>
                            <li>&nbsp;&nbsp;<span>{props.data.bath}</span>&nbsp;<img className="fr" src='/wp-content/themes/fyansford/images/bath-icon.svg' alt="" width="25px"/></li>
                            <li>&nbsp;&nbsp;<span>{props.data.car}</span>&nbsp;<img className="fr" src='/wp-content/themes/fyansford/images/car-icon.svg' alt="" width="25px"/></li>
                        </ul>
                    </div>
                </div>

                <div className="cf p-b-1 m-b-1 brd-bottom">
                    <div className="fl w-50 tl">
                        <p className="small-grey-font">Land Size<span className="fcolor-og small-grey-font"> {props.data.area}m<sup>2</sup></span></p>
                    </div>

                    <div className="fr w-50 tr">
                        <p className="small-grey-font">Frontage<span className="fcolor-og small-grey-font"> {props.data.frontage}m</span></p>
                    </div>
                </div>

                <div className="cf m-b-05">
                    <div className="fl w-50 select-package-download-icon">
                        <a className="download-flyer" href={props.data.pdf + '?package=' + props.data.id} target="_blank">
                            <i className="icon icon--download-alt"></i>
                            <span className="small-grey-font">Download Flyer</span>
                        </a>
                    </div>

                    <div className="fr w-50">
                        <a className="btn btn__enquire js-modalOpen fr" role="button" href="#" data-toggle="modal" data-target="#RegisterModal">
                            <span className="btn-land-available">ENQUIRE</span>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default PackageSearchGridItem;


/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/elements/PackageSearchGridItem.js
 **/